import React from 'react';
import { Icon } from './Icon.js';
export const IconEqualsFill18 = ({ ...props }) => {
    return (React.createElement(Icon, { size: "18px", ...props },
        React.createElement("path", { d: "m15.25,7.5H2.75c-.4141,0-.75-.3359-.75-.75s.3359-.75.75-.75h12.5c.4141,0,.75.3359.75.75s-.3359.75-.75.75Z", strokeWidth: "0", fill: "currentColor" }),
        React.createElement("path", { d: "m15.25,12H2.75c-.4141,0-.75-.3359-.75-.75s.3359-.75.75-.75h12.5c.4141,0,.75.3359.75.75s-.3359.75-.75.75Z", strokeWidth: "0", fill: "currentColor" })));
};
//# sourceMappingURL=IconEqualsFill18.js.map